import HttpMethod from "../models/HttpMethod";
import HttpResponse from "../models/HttpResponse";
import HttpErrorResponse from "../models/HttpErrorResponse";
import HttpSuccessResponse from "../models/HttpSuccessResponse";

async function request<T>(method: HttpMethod, path: string, token?: string, payload?: object | string): Promise<HttpResponse<T>> {
  const headers = new Headers();
  let body;

  if (token) {
    headers.append("Authorization", "Bearer " + token);
  }

  if (payload) {
    headers.append("Content-Type", "application/json");
    body = JSON.stringify(payload);
  }

  try {
    const response = await fetch(`https://${path}`, { method, headers, body });
    let responseBody;

    if (response.body) {
      const contentType = response.headers.get("Content-Type");
      const isJsonResponse = contentType && contentType.includes("application/json");

      if (isJsonResponse) {
        responseBody = await response.json();
      } else {
        responseBody = await response.text();
      }
    }

    if (response.ok) {
      return new HttpSuccessResponse<T>(responseBody);
    } else {
      return new HttpErrorResponse(response, responseBody);
    }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : "Network request failed";
    const headersArr = [];

    for (const header of headers) {
      const [name, value] = header;
      headersArr.push({ name, value });
    }

    throw new Error(`${errorMessage}, sent with headers: ${JSON.stringify(headersArr)}`);
  }
}

async function get<T>(url: string, token?: string): Promise<HttpResponse<T>> {
  return request("GET", url, token);
}

async function patch<T>(url: string, payload: object | string, token?: string): Promise<HttpResponse<T>> {
  return request("PATCH", url, token, payload);
}

async function put<T>(url: string, payload: object | string, token?: string): Promise<HttpResponse<T>> {
  return request("PUT", url, token, payload);
}

async function post<T>(url: string, payload: object | string, token?: string): Promise<HttpResponse<T>> {
  return request("POST", url, token, payload);
}

async function del<T>(url: string, token?: string): Promise<HttpResponse<T>> {
  return request("DELETE", url, token);
}

export { get, patch, put, post, del };
